import * as yup from 'yup';

const TopicSchema = () =>
  yup.object().shape({
    topics: yup.array(),
  });

export default TopicSchema;
